import { Box, styled, Typography } from '@material-ui/core';

export const Container = styled(Box)({
  borderRadius: '20px',
  border: '1px solid #EEF0F2',
  background:
    'linear-gradient(103deg, #DFE0EB 18.51%, #F5F2F2 47.89%, #DDE5F6 89.3%)',
  boxShadow:
    '0px 24px 48px -8px rgba(48, 54, 60, 0.12), 0px 4px 4px 0px rgba(48, 54, 60, 0.04)',

  display: 'flex',
  width: '720px',
  padding: '0px 16px',
  flexDirection: 'column',
  alignItems: 'flex-start'
});

export const Header = styled(Box)({
  display: 'flex',
  padding: '8px 0px 16px 0',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '4px',
  alignSelf: 'stretch'
});

export const TitleContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
});

export const Title = styled(Typography)({
  color: '#333D47',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: ' 24px',
  letterSpacing: 0
});

export const Footer = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 8
});

export const InputBox = styled(Box)({
  display: 'flex',
  padding: '12px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  alignSelf: 'stretch',
  borderRadius: '20px',
  border: '1px solid #EEF0F2',
  background: '#F8F9FA',
  height: 215
});

export const InputBoxFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch'
});

export const InputBoxButtons = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 2
});
